var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.8008,
    cy: 18.8008,
    r: 18.3008,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M13.9 15.35h2.7v9.35h-2.7V15.35zm1.35-4.2c.86 0 1.55.69 1.55 1.55s-.69 1.55-1.55 1.55-1.55-.69-1.55-1.55.69-1.55 1.55-1.55zM18.05 15.35h2.58v1.28h.04c.36-.68 1.24-1.4 2.55-1.4 2.73 0 3.23 1.8 3.23 4.13v5.34h-2.7v-4.74c0-1.13-.02-2.58-1.57-2.58-1.57 0-1.81 1.22-1.81 2.49v4.83h-2.7V15.35h.38z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.888b9d06aeeceead98cbd5c2dad93876.svg";
export { ForwardRef as ReactComponent };